import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import TableActions from './TableActions'
import { ExcelExportMode } from '../helpers/excelExportRequest'

interface Props {
    pageName: string
    /** İşaretli satır sayısı; 0 ise "Seçilenler" pasif. */
    selectedCount: number
    onExport: (mode: ExcelExportMode) => void
    /** Satır seçimi olmayan ekranlarda (raporlar) "Seçilenler" gösterilmez. */
    allowSelected?: boolean
}

/**
 * Bütün liste ekranlarında aynı Excel menüsü:
 * - Aktif Sayfa: ekranda görünen sayfa
 * - Seçilenler: işaretli satırlar
 * - Tümü: kolon filtrelerine (ve varsa paneldeki alanlara) uyan bütün kayıtlar
 * Kullanıcının o ekranda Excel yetkisi yoksa menü görünmez.
 */
const ExcelExportMenu = ({ pageName, selectedCount, onExport, allowSelected = true }: Props) => {
    const auth = useSelector((state: RootState) => state.auth)

    if (!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canExcel)
        return null

    return (
        <TableActions
            title='Excel'
            faIcon='fa-download'
            list={[
                { text: 'Aktif Sayfa', onClick: () => onExport('page') },
                allowSelected ? { isDisabled: selectedCount == 0, text: 'Seçilenler', onClick: () => onExport('selected') } : undefined,
                { text: 'Tümü', onClick: () => onExport('all') },
            ]}
        />
    )
}

export default ExcelExportMenu
